import React from 'react';
import { Stack } from '@grubhubprod/gh-cookbook-react';
import { MenuItem } from 'src/components/enterprise/navigation/NavMenu/MenuItem';
import type { IMenuItemsConfig } from 'src/components/enterprise/navigation/Navigation';

interface InternalAdminMenuItemsProps {
  menuItems: IMenuItemsConfig[];
}

export const InternalAdminMenuItems: React.FC<InternalAdminMenuItemsProps> = ({
  menuItems,
}) => {
  const leftMenuItems = menuItems.filter(({ rightSide }) => !rightSide);
  const rightMenuItems = menuItems.filter(({ rightSide }) => rightSide);

  return (
    <Stack display="flex" flex={1}>
      <Stack display="flex" flex={1}>
        {leftMenuItems.map((config) => (
          <MenuItem
            key={config.menu}
            menu={config.menu}
            mainRoute={config.mainRoute}
            icon={config.icon}
            matchingPathnames={config.matchingPathnames}
          />
        ))}
      </Stack>
      <Stack display="flex">
        {rightMenuItems.map((config) => (
          <MenuItem
            key={config.menu}
            menu={config.menu}
            mainRoute={config.mainRoute}
            icon={config.icon}
            matchingPathnames={config.matchingPathnames}
          />
        ))}
      </Stack>
    </Stack>
  );
};
